import StudentReport from '@/shared/publish/MyPublications/PublishedLists/StudentReport'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/publish/MyPublications/PublishedLists/StudentReport',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <StudentReport />
}
